export default {
  commissions_pending: false,
  commissions: [],
  commissions_refresh_pending: false,
  lastModified: null
}
